import { Component, OnInit, OnChanges, Input, Output, EventEmitter } from '@angular/core';
import { ConfigService } from '../commons/config.service';
import { SessionService } from '../commons/session.service';
import { ScrollService } from '../commons/scroll.service';
import { TranslateService } from '../commons/translate.service';
import { WebsiteInterfaceService } from '../commons/website-interface.service';
import { ConfiguratorApiService } from '../commons/configurator-api.service';
import { LoadingPanelService } from '../commons/loading-panel.service';
import { Param, KeyValue, ProductConfig, ValidParamConfig } from '../commons/models';
import { CartService } from '../commons/cart.service';
import { UtilitiesService } from '../commons/utilities.service';

@Component({
  selector: 'configurator',
  template: require('./configurator.component.html'),
  styles: [require('./configurator.component.scss')]
})
export class ConfiguratorComponent implements OnInit, OnChanges {
  hasPackage: boolean;

  showNoPackageSelectedModal: boolean;

  @Input() productConfig: ProductConfig;
  @Input() tables: string;

  @Output() configChange: EventEmitter<any>;

  errors: string;

  get validParams(): ValidParamConfig[] {
    let t = !this.tables ? null : this.tables.split(',');
    let ret = [];

    this.session.validParams.forEach(vp => {
      if (t === null) {
        ret.push(vp);
      } else {
        ret.push({
          page: vp.page,
          params: vp.params.filter(p => t.indexOf(p.table) >= 0),
          hidden: vp.hidden,
          image: vp.image,
          isPackage: vp.isPackage
        });
      }
    });

    return ret;
  }

  get model() {
    return this.session.thisModel;
  }

  constructor(
    private config: ConfigService,
    public session: SessionService,
    public scroll: ScrollService,
    private translate: TranslateService,
    private configApi: ConfiguratorApiService,
    private website: WebsiteInterfaceService,
    private loadingPanel: LoadingPanelService,
    public cartService: CartService,
    public utilities: UtilitiesService,
  ) { }


  ngOnInit() {
    //console.log('ngOnInit - configurator.component' + this.session.productConfig.xml);
    // if (this.productConfig) {
    //   this.hasPackage = this.productConfig.hasPackage;
    //   this.session.configureAsPackage = this.productConfig.hasPackage;
    //   this.session.getParamTree();
    // }

  }


  ngOnChanges() { // quando cambia l'Input (productConfig)
    ////console.log('ngOnChanges - configurator - ' + this.productConfig.name);
    if (this.productConfig) {
      this.hasPackage = this.productConfig.hasPackage;
      this.session.configureAsPackage = this.productConfig.hasPackage;
      this.session.getParamTree();
    }
  }

  group(values: any[], size: number) {
    let ret = [];
    let groups = Math.floor(values.length / size);
    for (let i = 0; i < groups; i++) {
      ret.push({ values: values.slice(i * size, (i + 1) * size) });
    }
    if ((values.length % size) !== 0) {
      ret.push({ values: values.slice(groups * size) });
    }
    return ret;
  }

  closeNoPackageSelectedModal(switchToCustom: boolean) {
    this.showNoPackageSelectedModal = false;

    if (switchToCustom) {
      this.session.changeParam(this.session.lastChangeParam, this.session.lastChangeValue);
      this.session.configureAsPackage = false;
    }
  }



  getParamImage(name: string) {
    return `${this.config.imagesUrl}/${this.productConfig.name}/Param_${name}.jpg`;
  }

  paramChanged(param: Param, value: string) {
    this.utilities.cartTOTAL();
    this.session.changeParam(param, value);
    this.scroll.ResetScrollLeft(this.cartService.cart.currentCartProduct ? this.cartService.cart.currentCartProduct.format : '');
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/configurator/configurator.component.ts